import { Block } from 'baseui/block';
import { Link, useNavigate } from 'react-router-dom';
import { styled, useStyletron, withStyle } from 'baseui';
import { useEffect, useState } from 'react';
import { ListItem, SHAPE } from 'baseui/list';
import { GetObjectUrl } from '../../../utils/navigationService';
import { Button } from 'baseui/button';
import { ChevronRight } from 'baseui/icon';
import { GetAppIcon, IsSmartApp } from '../../automationObjectsSelector';
import { LabelMedium, LabelSmall, LabelXSmall, ParagraphXSmall } from 'baseui/typography';
import { AiOutlineAppstore } from 'react-icons/ai';
import { getPlantId } from '../../utils';


const ListPanelWrapper = (props: any) => {
    const [css, theme] = useStyletron();
    const [url, setUrl] = useState('')
    const navigate = useNavigate();

    useEffect(() => {
        setUrl(props.url ? props.url : GetObjectUrl(props.resourceGroupId, props.id));
    }, [props.url, props.resourceGroupId, props.id]);


    const AppIcon = GetAppIcon(props.schema) || AiOutlineAppstore;
    const plantId = getPlantId(props);
    const isSmartApp = IsSmartApp({ tag: props.schema });
    const iconSize = props.small ? theme.sizing.scale500 : theme.sizing.scale800;

    const handleClick = (e) => { e.stopPropagation(); e.preventDefault(); navigate(url) }

    return (

        <ListItem shape={SHAPE.ROUND}
            overrides={{
                Root: {
                    style: ({ $theme }) => ({
                        ":hover": {
                            background: $theme.colors.primary50
                        }
                    })
                }
            }}
            onClick={handleClick}
            sublist={props.small}
            artwork={(props) => <AppIcon width={iconSize} {...props} color={theme.colors.contentTertiary}></AppIcon>}
            endEnhancer={() =>
                <>
                    {props.endEnhancer}
                    <Button onClick={handleClick} size="compact" kind="tertiary" shape="circle">
                        <ChevronRight size={theme.sizing.scale800} />
                    </Button>
                </>}>
            <Block
                marginTop={theme.sizing.scale200}
                marginBottom={theme.sizing.scale200}
                gridGap={theme.sizing.scale200}
                display='flex'
                width={'100%'}
                justifyContent={'space-between'}
                flexDirection='row'>
                <Block gridGap={theme.sizing.scale200} display='inline-flex'                >
                    {isSmartApp && <>🧠</>}
                    {!props.small &&
                        <Block display='flex' flexDirection='row' alignItems='center' justifyContent='flex-start' gridGap='10px'>
                            <div>
                                <LabelSmall>{props.description}</LabelSmall>
                                {!plantId && <ParagraphXSmall className={css({ textOverflow: 'ellipsis' })} margin={0}>{props.name}</ParagraphXSmall>}
                                {plantId && <ParagraphXSmall className={css({ textOverflow: 'ellipsis' })} margin={0}>{plantId}</ParagraphXSmall>}

                            </div>
                        </Block>
                    }
                    {props.small &&
                        <LabelXSmall>{props.description}</LabelXSmall>
                    }
                </Block>
                {props.children}
            </Block >
        </ListItem >

    )
}

export default ListPanelWrapper;

